export default "__VITE_ASSET__KlNgSlqV__"